module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-france.a915061b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-france.png
// module id = 2626
// module chunks = 11